import { FC } from "react"
import cx from "classnames"
import Modal, { ModalProps } from "@/components/Modal"
import CancelButton from "@/components/OutlineButton/CancelButton"
import DeleteButton from "@/components/Button/DeleteButton"
import { useDeleteAdminProxy } from "../../hooks/useDeleteProxy"
import type { Proxy } from "@/types/entities/proxy"

type Props = {
  className?: string
  data: Proxy[]
  onDeleteSuccess?: () => void
} & ModalProps

const DeleteProxyModal: FC<Props> = ({
  className,
  open,
  data,
  onClose,
  onDeleteSuccess,
  ...rest
}: Props) => {
  const {
    deleteAdminProxy,
    response: { isLoading },
  } = useDeleteAdminProxy()
  if (!data.length) {
    return null
  }
  const handleDelete = async () => {
    try {
      const response = await deleteAdminProxy(data.map(({ _id }) => _id))
      if (response) {
        onDeleteSuccess && onDeleteSuccess()
      }
    } catch (e) {
      console.error(e)
    } finally {
      onClose && onClose()
    }
  }
  const title =
    data.length > 1 ? `Delete ${data.length} Proxies` : "Delete Proxy"
  const targetText =
    data.length > 1 ? `${data.length} proxies` : `“${data[0].ip}”`
  return (
    <Modal
      title={title}
      open={open}
      onClose={onClose}
      className={cx("", className)}
      onSubmit={handleDelete}
      actions={
        <div className="flex gap-4">
          <CancelButton onClick={onClose} disabled={isLoading} />
          <DeleteButton disabled={isLoading} />
        </div>
      }
      {...rest}
    >
      <span className="leading-6 text-base break-all">
        Are you sure you want to delete{" "}
        <span className="font-semibold">{targetText}</span>?
      </span>
    </Modal>
  )
}

export default DeleteProxyModal
